import { ENDPOINT_PROFILE } from '../config'
import type { UploadProfilePictureParams } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Upload a profile picture for the current user
 */
const uploadProfilePicture = async (
  params: UploadProfilePictureParams,
): Promise<{ url: string }> => {
  const formData = new FormData()
  formData.append('file', params.file)

  const response = await AuthAxios.post<{ url: string }>(
    `${ENDPOINT_PROFILE}/picture`,
    formData,
    {
      headers: {
        // Must explicitly set to undefined to override the default 'application/json'
        // This allows axios to auto-set 'multipart/form-data' with the correct boundary
        'Content-Type': undefined,
      },
    }
  )

  return response.data
}

export default uploadProfilePicture
